import { render, staticRenderFns } from "./NotificationInfo.vue?vue&type=template&id=0197b57e&scoped=true"
import script from "./NotificationInfo.vue?vue&type=script&lang=js"
export * from "./NotificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197b57e",
  null
  
)

export default component.exports